import React from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";
import committies from "../../utils/committees.json";
import CommitteeTable from "../../components/committeeMembersComp/CommitteeTable";

type DataProps = {
  Incharge: string[];
  Members: string[];
};

const GrievanceRedressal = () => {
  const fa: Array<DataProps> = [
    {
      Incharge: committies
        .find((obj) =>
          obj.name.includes("Student Grievance and ReDressal Committee")
        )
        ?.incharge[0].split("- ")[1]
        .split(",") as Array<string>,
      Members: committies
        .find((obj) =>
          obj.name.includes("Student Grievance and ReDressal Committee")
        )
        ?.incharge[1].split("- ")[1]
        .split(",") as Array<string>,
    },
  ];
  const titles = ["Sr.No.", "Incharge", "Members"];
  return (
    <Box
      sx={{
        backgroundColor: "primary.light",
        p: { xs: 1, md: 3 },
        width: "90%",
        margin: "auto",
      }}
    >
      <Stack
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{ border: "1px solid #e0e0e0", p: { xs: 1, md: 3 } }}
      >
        <Typography fontSize={16}>
          Modern College of Physiotherapy is committed to providing a supportive
          and conducive learning environment for all students. To address any
          grievances or concerns that may arise, the college has established a
          Grievance Redressal Committee. This committee comprises
          representatives from the faculty, administration, and student body,
          ensuring a comprehensive approach to resolving issues. The committee
          provides a confidential platform for students to voice their concerns
          related to academic, administrative, or any other matters. The
          committee investigates each complaint thoroughly and takes appropriate
          action to find a fair and equitable resolution. The primary objective
          of the committee is to create a transparent and accessible system
          where students feel heard and valued, fostering a positive and
          harmonious campus atmosphere.
        </Typography>
        <Stack
          spacing={2}
          direction="column"
          alignItems="center"
          justifyContent="center"
        >
          <Grid
            container
            textAlign="center"
            justifyContent={"center"}
            mt={{ xs: "16px !important", md: "32px !important" }}
          >
            <Grid item m={2}>
              <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                Student Grievance and ReDressal Committee
              </Typography>
            </Grid>
            <Grid
              container
              sx={{
                justifyContent: "center",
                alignItems: "center",
                margin: "auto",
              }}
            >
              <CommitteeTable titles={titles} data={fa} />
            </Grid>
          </Grid>
        </Stack>
      </Stack>
    </Box>
  );
};

export default GrievanceRedressal;
